<template>
  <div
    :class="{ en: getLang == 'en' }"
    class="container container-network font"
  >
    <div class="lang" v-if="getLang == 'he'" @click="setLang('en')">
      English
    </div>
    <div class="lang" v-else @click="setLang('he')">
      עברית
    </div>

    <div class="title">{{ $t("networkComputer.serverApp") }}</div>
    <div class="title-list">
      {{ $t("networkComputer.maxStationsOH") }} {{ max }} ({{
        $t("networkComputer.available")
      }}
      - {{ leftToUse }})
    </div>
    <div class="title-list">
      {{ $t("networkComputer.maxStationsMEF") }} {{ maxMef }} ({{
        $t("networkComputer.available")
      }}
      - {{ mefLeftToUse }})
    </div>
    <div class="list-computer ">
      <div class="title-list">
        {{ $t("networkComputer.compList") }}
      </div>
      <div class="inner-list-computer">
        <div class="header-content dir-rtl rtl">
          <div class="name">{{ $t("networkComputer.nameComputer") }}</div>
          <!-- <div class="time">{{ $t("networkComputer.connect") }}</div> -->
          <div></div>
        </div>
        <div class="content ">
          <div class="item-comp-net" v-for="client in clients" :key="client.id">
            <span class="name">
              {{ client.address }}
            </span>
            <!-- <span class="time">
              2:45:09
            </span> -->
            <div class="mef-net-btn">
              <div
                v-if="client.mef"
                class="btn btn-small"
                @click="disconnectStation(client.id, true)"
              >
                {{ $t("networkComputer.disconnectMef") }}
              </div>
              <div
                class="btn btn-small"
                @click="disconnectStation(client.id, false)"
              >
                {{ $t("general.disconnect") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer flex border-t-light ">
      <template v-if="$store.state.networkModule.serverAsStation">
        <div>{{ $t("networkComputer.serverAsStation") }}</div>
      </template>
      <template v-else>
        <div>{{ $t("networkComputer.turnOnAsStation") }}</div>
        <div class="btn" @click="innersetServerToBoth">
          {{ $t("mainTools.active") }}
        </div>
      </template>
    </div>
    <div class="footer flex" style="justify-content:center">
      <div style="display:flex;flex-direction:column">
        <div>
          <div>
            <label for="oldpsw">{{ $t("general.old_password") }}</label>
            <input id="oldpsw" v-model="oldp" type="password" />
          </div>
          <div>
            <label for="newpsw">{{ $t("general.new_password") }}</label>
            <input id="newpsw" v-model="newp" type="password" />
          </div>
        </div>
        <div style="padding-top:10px">
          <div class="btn" @click="setNewPsw">
            {{ $t("general.confirm") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixnet from "@/mixing/mixNet";
import { Axios } from "@/services/_axios";
import { getAppInfo } from "@/services/offline/license.js";
import { loadLanguageAsync } from "@/localization/local";

export default {
  mixins: [mixnet],
  data() {
    return {
      oldp: "",
      newp: "",
      max: 0,
      maxMef: 0,
      langChanged: false,
    };
  },
  computed: {
    getLang() {
      let react = this.langChanged;
      return localStorage.getItem("netLang") || "he";
    },
    isServerAsStationActive() {
      return true;
    },
    leftToUse() {
      return this.max - this.clients.length;
    },
    mefLeftToUse() {
      return this.maxMef - this.clients.filter((a) => a.mef).length;
    },
  },
  methods: {
    setLang(lang) {
      loadLanguageAsync(lang);
      localStorage.setItem("netLang", lang);
      this.langChanged = !this.langChanged;
    },
    async setNewPsw() {
      if (!this.oldp || !this.newp) {
        return;
      }
      let ret = await Axios.post("/api/network/new-psw", {
        oldp: this.oldp,
        newp: this.newp,
      });
      this.oldp = "";
      this.newp = "";
      let oldPswCorrect = true;

      if (ret.data == "bad") {
        oldPswCorrect = false;
      }

      //check for old psw
      if (!oldPswCorrect) {
        this.$notify({
          type: "error",
          message: this.$t("general.wrong_psw"),
          timeout: 2000,
        });
        return;
      }
      let changed = false;
      if (ret.data == "ok") {
        changed = true;
      }

      //set new psw
      if (changed) {
        this.$notify({
          type: "success",
          message: this.$t("general.success_action"),
          timeout: 2000,
        });
      } else {
        this.$notify({
          type: "error",
          message: this.$t("general.error_action"),
          timeout: 2000,
        });
      }
    },
  },
  async created() {
    let lang = localStorage.getItem("netLang") || "he";
    this.setLang(lang);
    try {
      const data = await getAppInfo();

      this.max = data.Stations;
      this.maxMef = data.MefStation;
    } catch (ex) {
      console.error(ex);
    }
  },
};
</script>

<style lang="scss" scoped>
.container-network {
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  // height: 100%;
  // width: 100%;
  margin-top: 90px;
  max-width: 400px;
  margin: 90px auto 10px;
  .footer {
    justify-content: space-between;
    display: flex;
    padding: 15px 20px;
    margin-top: 40px;
    font-weight: bold;
  }
}
.mef-net-btn {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
}
.item-comp-net {
  padding: 10px 20px;
  min-height: 47px;
  height: auto;
  border-bottom: 1px solid rgba(158, 158, 158, 0.267);
  align-items: center;
  display: flex;
  .btn {
    margin-right: auto;
  }
  &:hover {
    background-color: rgb(242, 241, 241);
    // cursor: pointer;
  }
}
.header-content {
  padding: 0 20px;
  font-size: 12px;
  font-weight: bold;
  border-bottom: 1px solid rgba(184, 184, 184, 0.267);
  display: flex;
  color: rgb(177, 177, 177);
  & > div {
    flex-grow: 1;
  }
}
.name {
  max-width: 150px;
  width: 150px;
}
.time {
  color: rgb(177, 177, 177);
  padding-right: 15px;
}
.title {
  font-size: 16px;
  color: var(--custom-color1);
  //    width: 700px;
  margin: 0 auto;
}
.list-computer {
  border: 1px solid #e8e8e8;
  border-radius: 5px;

  margin: 20px auto;
  box-shadow: 1px 2px 7px #00000026;
  .title-list {
    background-color: #f5f5f5;
    padding: 0 20px;
    height: 47px;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    border-bottom: 1.5px solid #e8e8e8;
  }
}
.lang {
  color: var(--custom-color1);
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}
.en {
  direction: ltr;
  text-align: left;
}
</style>
